import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'mcg-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css'],
  encapsulation: ViewEncapsulation.Emulated,
  imports: [CommonModule],
  host: { 'hostID': crypto.randomUUID().toString() }

})
export class LoaderComponent {
  @Input() showLoader: boolean = false;
  @Input() message?: string = '';
}
